import { type RedirectRequest } from '@azure/msal-browser';

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'offline_access', 'profile', 'email'],
  state: window.location.href,
};
